import React, { useMemo } from 'react'
import { styled } from '@mui/material/styles'
import Paper from '@mui/material/Paper'
import { Box, Chip, Typography, alpha } from '@mui/material'
import { setStageStyle } from './setStageStyle'
import { formatCurrencyString } from './aggregateStageTotals'
import DealListItem from './DealListItem'

const FlexPaper = styled(Paper)(({ theme }) => ({
  flex: '0 0 auto',
  minWidth: '15.5%',
  maxWidth: '15.5%',
  display: 'flex',
  flexDirection: 'column',
  border: '2px solid',
  borderColor: theme.palette.text.secondary,
  margin: '0 8px',
}))

const Header = styled('h3')<{ label?: string }>(({ label }) => ({
  margin: 0,
  textAlign: 'center',
  color: 'black',
  padding: '8px 0',
  position: 'sticky',
  top: 0,
  zIndex: 1,
  width: '100%',
  backgroundColor: setStageStyle(label),
  borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
}))

const KanbanColumn = ({ columnId, items, label, total, grossProfit }) => {
  const memoizedItems = useMemo(
    () => items.map(item => <DealListItem key={item.SK} item={item} />),
    [items]
  )

  return (
    <FlexPaper>
      <Header label={label}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'left',
            justifyContent: 'center',
            px: 2,
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: 1 }}>
            <Typography sx={{ fontWeight: 'bold', textAlign: 'left', fontSize: 18 }}>{label}</Typography>
            <Chip label={items.length} />
          </Box>
          <Typography sx={{ textAlign: 'left' }}>{`Total: ${formatCurrencyString(total) || '0.00'}`}</Typography>
          <Typography sx={{ textAlign: 'left' }}>{`Gross Profit: ${
            formatCurrencyString(grossProfit) || '0.00'
          }`}</Typography>
        </Box>
      </Header>
      <Box
        sx={{
          flex: 1,
          minHeight: '50px',
          overflowY: 'auto',
        }}
      >
        {memoizedItems.length > 0 ? (
          memoizedItems
        ) : (
          <Typography sx={{ textAlign: 'center', padding: 2 }}>No deals</Typography>
        )}
      </Box>
    </FlexPaper>
  )
}

export default React.memo(KanbanColumn)
